/** Wie viele Köpfe zeigt der Stapel? Höchstens 3, bei mehr 2 Köpfe und „+N“ (AUFGABEN-STUFE2.md, Abschnitt 3.5). */
export function stapelTeile(anzahl: number): { koepfe: number; mehr: number } {
  if (anzahl <= 3) return { koepfe: anzahl, mehr: 0 };
  return { koepfe: 2, mehr: anzahl - 2 };
}
